__turbopack_context__.v({
  "AboutVideo": "AboutUs-module__oSqK1a__AboutVideo",
  "blockSection": "AboutUs-module__oSqK1a__blockSection",
  "bodyText": "AboutUs-module__oSqK1a__bodyText",
  "breadcrumbWrap": "AboutUs-module__oSqK1a__breadcrumbWrap",
  "featureCard": "AboutUs-module__oSqK1a__featureCard",
  "featureGrid": "AboutUs-module__oSqK1a__featureGrid",
  "featureIconWrap": "AboutUs-module__oSqK1a__featureIconWrap",
  "featureText": "AboutUs-module__oSqK1a__featureText",
  "featureTitle": "AboutUs-module__oSqK1a__featureTitle",
  "heading": "AboutUs-module__oSqK1a__heading",
  "marquee": "AboutUs-module__oSqK1a__marquee",
  "marqueeImage": "AboutUs-module__oSqK1a__marqueeImage",
  "marqueeTile": "AboutUs-module__oSqK1a__marqueeTile",
  "marqueeTrack": "AboutUs-module__oSqK1a__marqueeTrack",
  "page": "AboutUs-module__oSqK1a__page",
  "scrollLogoMarquee": "AboutUs-module__oSqK1a__scrollLogoMarquee",
  "sectionHeader": "AboutUs-module__oSqK1a__sectionHeader",
  "standard-heading": "AboutUs-module__oSqK1a__standard-heading",
  "statCell": "AboutUs-module__oSqK1a__statCell",
  "statInner": "AboutUs-module__oSqK1a__statInner",
  "statLabel": "AboutUs-module__oSqK1a__statLabel",
  "statValue": "AboutUs-module__oSqK1a__statValue",
  "statsGrid": "AboutUs-module__oSqK1a__statsGrid",
  "valueCard": "AboutUs-module__oSqK1a__valueCard",
  "valueGrid": "AboutUs-module__oSqK1a__valueGrid",
  "valueIconWrap": "AboutUs-module__oSqK1a__valueIconWrap",
  "valueText": "AboutUs-module__oSqK1a__valueText",
  "valueTitle": "AboutUs-module__oSqK1a__valueTitle",
  "valuesSection": "AboutUs-module__oSqK1a__valuesSection",
  "videoWrap": "AboutUs-module__oSqK1a__videoWrap",
  "whoCopy": "AboutUs-module__oSqK1a__whoCopy",
  "whoGrid": "AboutUs-module__oSqK1a__whoGrid",
  "whoSection": "AboutUs-module__oSqK1a__whoSection",
});
